import "./enlacesInformativos.css";

const PoliticasCancelacion = () => {
  return (
    <div className="informacion mx-auto border-0 w-[100%] md:w-[80%] min-h-screen py-[30px] lg:px-0 px-[20px]">
      <section>
        <h1>Política de Cancelaciones y Modificaciones</h1>

        <h2>Para huéspedes</h2>

        <h3>1. Cancelaciones con reembolso:</h3>
        <ul>
          <li>
            Cancelación con 7 días o más de anticipación: reembolso del 100%
            (excepto tarifas de servicio).
          </li>
          <li>
            Cancelación entre 6 y 3 días antes del check-in: reembolso del 50%.
          </li>
          <li>
            Cancelación con menos de 72 horas de anticipación: sin reembolso.
          </li>
        </ul>

        <h3>2. Cancelaciones por fuerza mayor:</h3>
        <ul>
          <li>
            Se evaluarán casos de enfermedad grave, desastres naturales o
            restricciones gubernamentales con documentación comprobable.
          </li>
          <li>
            Si se aprueba, el huésped podrá reprogramar su estadía o recibir un
            reembolso del 50%.
          </li>
        </ul>

        <h3>3. Modificaciones de reserva:</h3>
        <ul>
          <li>
            Se pueden hacer cambios de fecha con más de 5 días de anticipación,
            sujeto a disponibilidad y posibles ajustes de tarifa.
          </li>
          <li>
            Modificaciones con menos de 5 días serán a discreción del anfitrión.
          </li>
        </ul>

        <hr />

        <h2>Para anfitriones</h2>

        <h3>1. Cancelaciones por parte del anfitrión:</h3>
        <ul>
          <li>
            Si un anfitrión cancela una reserva confirmada, deberá ofrecer una
            solución alternativa (otro alojamiento en la plataforma con
            características similares).
          </li>
          <li>
            Si no se encuentra una solución, el anfitrión deberá reembolsar el
            100% del monto pagado y asumirá una penalización del 10% del total
            de la reserva (deducido en su siguiente pago).
          </li>
          <li>
            Cancelaciones reiteradas podrían resultar en suspensión del perfil.
          </li>
        </ul>

        <h3>2. Modificaciones y problemas con la estadía:</h3>
        <ul>
          <li>
            Si el alojamiento no cumple con lo anunciado o tiene problemas
            serios (falta de agua, electricidad, higiene deficiente, etc.), el
            huésped podrá solicitar una solución en un plazo de 24 horas tras el
            check-in.
          </li>
          <li>
            Si el anfitrión no resuelve el problema, la plataforma podrá
            reubicar al huésped o gestionar un reembolso parcial.
          </li>
        </ul>

        <hr />

        <h2>Responsabilidad de la plataforma</h2>
        <p>
          Rumbo Punilla actúa como intermediario y no es responsable de
          incumplimientos de anfitriones o huéspedes.
        </p>
        <p>
          Los pagos se gestionan a través de la plataforma, pero las disputas
          entre las partes deberán resolverse de acuerdo con estas políticas.
        </p>
        <p>
          Se recomienda a ambas partes comunicarse dentro de la plataforma para
          que quede registro de cualquier acuerdo o inconveniente.
        </p>
      </section>
    </div>
  );
};

export default PoliticasCancelacion;
